<div class="row mb-3">
    <div class="col-3">
        <img class="image-icon-sm" src="content/images/measurements.svg" />
        <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.sample-genotype.title' | translate}}</span>
    </div>
</div>
<div class="row mb-2">
    <div class="col d-flex justify-content-start align-items-center">
        <label>{{ 'study-editor.sample-genotype.select-sample-list' | translate}}</label>
        <div class="col-3 ms-2">
            <ng-select [items]="sampleLists" [(ngModel)]="selectedSampleList" (ngModelChange)="onSampleListChange()" [clearable]="false">
                <ng-template ng-label-tmp let-item="item">
                    {{ item.listName }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.listName }}
                </ng-template>
            </ng-select>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <div class="col">
                    <span jhiTranslate="global.total.entries" [translateValues]="{param: numberOfEntries}"></span>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-3 ps-0 pe-0">
    <!-- Germplasm Study Source Table Section -->
    <div>
        <div class="row">
            <div class="col-10">
                <div class="col d-flex align-items-center">
                    <label class="col-auto" jhiTranslate="global.records.per.page">Records per page: </label>
                    <div class="col-1 ms-2">
                        <select class="form-select form-select-sm"
                                [(ngModel)]="pageSize"
                                (change)="onPageSizeChange($event)">
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="col-5">
                        <button class="btn btn-sm btn-outline-info ms-2" (click)="clearFilters()"><i class="fa fa-filter-circle-xmark me-1"></i>
							<span jhiTranslate="study-editor.clear.filter">Clear Filter</span></button>
                    </div>
                </div>
            </div>
            <div class="col-2 d-flex justify-content-end align-items-center">
                <div class="ms-1">
                    <jhi-column-selector [displayedColumns]="displayedColumns"
                                         [columnDataService]="columnDataService"
                                         [showGroupToggle]="false"
                                         (reset)="onColumnSelectorReset()"
                    ></jhi-column-selector>
                </div>
            </div>
        </div>
        <!-- Data Table -->
        <div class="table-responsive mt-3">
            <div class="custom-scroll-style adjustable-height">
                <table id="germplasm-checks-table"
                       class="table table-striped table-bordered table-curved table-editable">
                    <thead class="sticky-header">
                    <tr>
                        @for (column of displayedColumns; track trackColumnsById(column)) {
                            @if (column.selected && column.visible) {
                                <th class="default">
                                    @if (getStaticColumnLabelKey(column.termId)) {
                                        {{ getStaticColumnLabelKey(column.termId) | translate }}
                                    } @else {
                                        {{ column.name }}
                                    }
                                        <span class="cursor-pointer ms-1"
                                              #p="ngbPopover"
                                              (click)="showColumnFilterPopover(column, p)"
                                              [autoClose]="'outside'"
                                              [ngbPopover]="columnFilterTemplate"
                                              container="body"
                                              [placement]="['bottom', 'right', 'auto']"
                                              triggers="manual">
                                    <i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
                                            @if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
                                                <i class="ps-1 fa fa-icon-active"
                                                   [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
                                        </i>
                                            }
                                </span>

                                </th>
                            }
                        }
                    </tr>
                    </thead>
                    <tbody>
                        @if (entries.length !== 0) {
                            @for (entry of entries; track trackRowsById(entry); let row = $index) {
                                <tr>
                                    @for (column of displayedColumns; track trackColumnsById(column); let col = $index) {
                                        <td *ngIf="column.selected && column.visible">
                                            @switch (true) {
                                                @case (column.termId === STATIC_COLUMN_SAMPLE_NAME) {
                                                   <truncate-span [textInput]="entry.sampleName"></truncate-span>
                                                }
                                                @case (column.termId === STATIC_COLUMN_SAMPLE_UUID) {
                                                    <truncate-span [textInput]="entry.sampleUUID"></truncate-span>
                                                }
                                                @case (column.termId === STATIC_COLUMN_SAMPLING_DATE) {
                                                    <truncate-span [textInput]="entry.samplingDate"></truncate-span>
                                                }
                                                @case (column.termId === STATIC_COLUMN_SAMPLING_TAKEN_BY) {
                                                    <truncate-span [textInput]="entry.takenBy"></truncate-span>
                                                }
                                                @case (column.termId === STATIC_COLUMN_GID) {
                                                    @if (hasViewGermplasmDetailsPermission) {
                                                        <span><a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.genotypeDataMap[column.name]?.value)"><truncate-span [textInput]="entry.genotypeDataMap[column.name]?.value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a></span>
                                                    } @else {
                                                        <truncate-span [textInput]="entry.genotypeDataMap[column.name]?.value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                    }
                                                }
                                                @case (column.termId === STATIC_COLUMN_DESIGNATION) {
                                                    @if (hasViewGermplasmDetailsPermission) {
                                                        <span><a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.genotypeDataMap['GID']?.value)"><truncate-span [textInput]="entry.genotypeDataMap[column.name]?.value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a></span>
                                                    } @else {
                                                        <truncate-span [textInput]="entry.genotypeDataMap[column.name]?.value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                    }
                                                }
                                                @default {
                                                    <truncate-span [textInput]="entry.genotypeDataMap[column.name]?.value" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                }
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td [attr.colspan]="displayedColumns.length" class="text-center py-3">
                                    {{ 'study-editor.no-records' | translate }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">

            <div>
				@if (numberOfEntries !== numberOfFilteredEntries) {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfFilteredEntries}"></span>
					<span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfEntries}"></span>
				} @else {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfEntries}"></span>
				}
            </div>

            <div>
                <div class="d-inline-block ms-3">
                    <ngb-pagination
                            [collectionSize]="numberOfFilteredEntries || numberOfEntries"
                            [(page)]="currentPage"
                            [pageSize]="pageSize"
                            [maxSize]="10"
                            [ellipses]="true"
                            [boundaryLinks]="true"
                            [rotate]="true"
                            (pageChange)="onPageChange($event)">
                    </ngb-pagination>
                </div>
                <div class="d-inline-block ms-3">
                    <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                    <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                           [min]="1" [max]="Math.ceil((numberOfFilteredEntries || numberOfEntries) / pageSize)"
                           [(ngModel)]="currentPage"
                           (change)="onPageChange(currentPage); $event.preventDefault()"/>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
    <div class="column-filter">
        <!-- Sorting Buttons -->
        <div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting !== false">
            <button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
                    [ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
            </button>
            <button (click)="sortColumn(columnDataForFilter,false)" class="btn"
                    [ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
            </button>
        </div>
        <!-- Regular Input Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode !== 'D'" class="mt-2">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   placeholder="{{ 'common.filter.value' | translate }}"
                   [title]="columnDataForFilter.possibleValues?.length ? ('study-editor.study-dataset.no.values.filter.title' | translate) : ''">

            <!-- Filter Options List -->
            <ul class="list-group mt-3" *ngIf="columnDataForFilter.possibleValues">
                <li class="list-group-item" *ngIf="!columnDataForFilter.query">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="columnDataForFilter.isSelectAll"
                               (change)="filterSelectAll(columnDataForFilter, columnDataForFilter.isSelectAll)">
                        <label class="form-check-label" jhiTranslate="global.select.all.items">Select all</label>
                    </div>
                </li>
                <li *ngFor="let option of columnDataForFilter.possibleValues | orderBy:'name' | filter:columnDataForFilter.query:'name'"
                    class="list-group-item">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="option.isSelectedInFilters"
                               (change)="filterSelectOption(option.isSelectedInFilters)">
                        <label class="form-check-label">
                            {{ isCategoricalDescriptionView ? option.displayDescription : option.name }}
                        </label>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Date Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode === 'D'" class="mt-3">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   ngbDatepicker="dp"
                   placeholder="{{ 'common.filter.value' | translate }}">
            <div class="mt-3">
                <ngb-datepicker #dp
                                [(ngModel)]="columnDataForFilter.query"
                                class="well well-sm"
                                (click)="$event.stopPropagation()">
                </ngb-datepicker>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-3">
            <div class="d-flex justify-content-around">
                <div>
                    <button class="btn btn-info ms-2"
                            (click)="filterByColumn(columnDataForFilter)"
                            title="{{ 'global.apply.all.filter' | translate }}" jhiTranslate="apply">
                        Apply
                    </button>
                    <button class="btn btn-secondary ms-2"
                            (click)="resetFilterByColumn(columnDataForFilter)"
                            title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </div>

</ng-template>
